import { get } from "lodash";
import { Fragment, useState } from "react";
import { TbFileUpload } from "react-icons/tb";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Grid,
  Typography,
  IconButton,
  Chip,
  Dialog as MUIDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Tooltip,
} from "@mui/material";
import { AiOutlineFileExclamation } from "react-icons/ai";

import { Reject } from "../../css components/Button";
import { colors } from "../../css components/Style";
import { uploadToS3 } from "../../../utils";
import { ComponentHeader } from "../../../components";

export default function FormThree({ formikProps, editState }) {
  const [deleteDialog, setDeleteDialog] = useState({ state: false });

  function handleClick(url) {
    window.open(url, "_blank");
  }

  const handleClose = () => {
    setDeleteDialog({ state: false });
  };

  function handleDelete(event, name) {
    formikProps.setValues((prev) => ({
      ...prev,
      [name]: "",
    }));
  }

  return (
    <Fragment>
      <Grid size={12}>
        <ComponentHeader title={"Company Documents"} />
      </Grid>

      <Grid size={12} display={"flex"} gap="10px">
        <div className="div-upload-document">
          {editState && (
            <IconButton disableFocusRipple>
              <input
                disabled={!editState}
                accept=".jpg,.jpeg,.png,.pdf"
                style={{ display: "none" }}
                id="contained-button-file-1"
                multiple
                onChange={(event) => handleFileChange(event, "gstCertificate")}
                type="file"
              />
              <label htmlFor="contained-button-file-1">
                <TbFileUpload
                  disabled={!editState}
                  style={{
                    fontSize: "25px",
                    color: colors.sprintexBlue,
                    cursor: "pointer",
                  }}
                />
              </label>
            </IconButton>
          )}

          <Typography color={colors.sprintexBlue}>
            Company GST Certificate
          </Typography>

          {!formikProps.values.gstCertificate && !editState && (
            <Tooltip title="PAN not found">
              <span>
                <AiOutlineFileExclamation
                  style={{
                    margin: "10px",
                    fontSize: "25px",
                    color: colors.warning,
                  }}
                />
              </span>
            </Tooltip>
          )}

          {!!formikProps.values.gstCertificate && (
            <Chip
              className="file-chip"
              style={{
                borderColor: colors.green,
                color: colors.green,
              }}
              label={formikProps.values.gstCertificate?.split("_").pop()}
              variant="outlined"
              onClick={() => handleClick(formikProps.values.gstCertificate)}
              {...(formikProps.values.is_brand_verified !== 1 &&
                formikProps.values.is_agency_verified !== 1 && {
                  deleteIcon: (
                    <DeleteIcon
                      disabled={!editState}
                      style={{
                        color: colors.error,
                        cursor: "pointer",
                      }}
                    />
                  ),
                  onDelete: (event) =>
                    setDeleteDialog({
                      state: true,
                      event: event,
                      target: "gstCertificate",
                    }),
                })}
            />
          )}
        </div>

        <div className="div-upload-document">
          {editState && (
            <IconButton disableRipple>
              <input
                disabled={!editState}
                accept=".jpg,.jpeg,.png,.pdf"
                style={{ display: "none" }}
                id="contained-button-file-2"
                multiple
                onChange={(event) =>
                  handleFileChange(event, "companyPanCertificate")
                }
                type="file"
              />
              <label htmlFor="contained-button-file-2">
                <TbFileUpload
                  disabled={!editState}
                  style={{
                    cursor: "pointer",
                    fontSize: "25px",
                    color: !editState ? "#cbcbcb" : colors.sprintexBlue,
                  }}
                />
              </label>
            </IconButton>
          )}

          <Typography color={colors.sprintexBlue}>
            Company PAN Certificate
          </Typography>

          {!!formikProps.errors.companyPanCertificate && formikProps.dirty && (
            <Typography color={colors.error} fontWeight={600}>
              Company PAN Certificate Is Required
            </Typography>
          )}

          {!!formikProps.values.companyPanCertificate && (
            <Chip
              className="file-chip"
              style={{
                borderColor: colors.green,
                color: colors.green,
              }}
              disabled={!editState}
              label={formikProps.values.companyPanCertificate?.split("_").pop()}
              variant="outlined"
              onClick={() =>
                handleClick(formikProps.values.companyPanCertificate)
              }
              {...(formikProps.values.is_brand_verified !== 1 &&
                formikProps.values.is_agency_verified !== 1 && {
                  deleteIcon: (
                    <DeleteIcon
                      disabled={!editState}
                      style={{
                        color: colors.error,
                        cursor: "pointer",
                      }}
                    />
                  ),
                  onDelete: (event) =>
                    setDeleteDialog({
                      state: true,
                      event: event,
                      target: "companyPanCertificate",
                    }),
                })}
            />
          )}

          {!formikProps.values.companyPanCertificate && !editState && (
            <Tooltip title="PAN not found">
              <span>
                <AiOutlineFileExclamation
                  style={{
                    margin: "10px",
                    fontSize: "25px",
                    color: colors.warning,
                  }}
                />
              </span>
            </Tooltip>
          )}
        </div>

        <div className="div-upload-document">
          {editState && (
            <IconButton disableRipple>
              <input
                disabled={!editState}
                accept=".jpg,.jpeg,.png,.pdf"
                style={{ display: "none" }}
                id="contained-button-file-3"
                multiple
                onChange={(event) =>
                  handleFileChange(event, "directorAadharCertificate")
                }
                type="file"
              />
              <label htmlFor="contained-button-file-3">
                <TbFileUpload
                  disabled={!editState}
                  style={{
                    cursor: "pointer",
                    fontSize: "25px",
                    color: colors.sprintexBlue,
                  }}
                />
              </label>
            </IconButton>
          )}

          <Typography color={colors.sprintexBlue}>
            Company Director's Aadhaar Certificate
          </Typography>

          {!formikProps.values.directorAadharCertificate && !editState && (
            <Tooltip title="Director Aadhaar not found">
              <span>
                <AiOutlineFileExclamation
                  style={{
                    margin: "10px",
                    fontSize: "25px",
                    color: colors.warning,
                  }}
                />
              </span>
            </Tooltip>
          )}

          {!!formikProps.values.directorAadharCertificate && (
            <Chip
              disabled={!editState}
              className="file-chip"
              style={{
                borderColor: colors.green,
                color: colors.green,
              }}
              label={formikProps.values.directorAadharCertificate
                ?.split("_")
                .pop()}
              variant="outlined"
              onClick={() =>
                handleClick(formikProps.values.directorAadharCertificate)
              }
              {...(formikProps.values.is_brand_verified !== 1 &&
                formikProps.values.is_agency_verified !== 1 && {
                  deleteIcon: (
                    <DeleteIcon
                      disabled={!editState}
                      style={{
                        color: colors.error,
                        cursor: "pointer",
                      }}
                    />
                  ),
                  onDelete: (event) =>
                    setDeleteDialog({
                      state: true,
                      event: event,
                      target: "directorAadharCertificate",
                    }),
                })}
            />
          )}
        </div>

        <div className="div-upload-document">
          {editState && (
            <IconButton disableRipple>
              <input
                disabled={!editState}
                accept=".jpg,.jpeg,.png,.pdf"
                style={{ display: "none" }}
                id="contained-button-file-4"
                multiple
                onChange={(event) =>
                  handleFileChange(event, "directorPanCertificate")
                }
                type="file"
              />
              <label htmlFor="contained-button-file-4">
                <TbFileUpload
                  disabled={!editState}
                  style={{
                    cursor: "pointer",
                    fontSize: "25px",
                    color: colors.sprintexBlue,
                  }}
                />
              </label>
            </IconButton>
          )}

          <Typography color={colors.sprintexBlue}>
            Company Director's PAN Certificate
          </Typography>

          {formikProps.errors.directorPanCertificate && formikProps.dirty && (
            <Typography color={colors.error} fontWeight={600}>
              Company Director's PAN Certificate Is Required
            </Typography>
          )}

          {!formikProps.values.directorPanCertificate && !editState && (
            <Tooltip title="Director's PAN Certificate not found">
              <span>
                <AiOutlineFileExclamation
                  style={{
                    margin: "10px",
                    fontSize: "25px",
                    color: colors.warning,
                  }}
                />
              </span>
            </Tooltip>
          )}

          {!!formikProps.values.directorPanCertificate && (
            <Chip
              disabled={!editState}
              className="file-chip"
              style={{
                borderColor: colors.green,
                color: colors.green,
              }}
              label={formikProps.values.directorPanCertificate
                ?.split("_")
                .pop()}
              variant="outlined"
              onClick={() =>
                handleClick(formikProps.values.directorPanCertificate)
              }
              {...(formikProps.values.is_brand_verified !== 1 &&
                formikProps.values.is_agency_verified !== 1 && {
                  deleteIcon: (
                    <DeleteIcon
                      disabled={!editState}
                      style={{
                        color: colors.error,
                        cursor: "pointer",
                      }}
                    />
                  ),
                  onDelete: (event) =>
                    setDeleteDialog({
                      state: true,
                      event: event,
                      target: "directorPanCertificate",
                    }),
                })}
            />
          )}
        </div>
      </Grid>

      <DeleteDialog deleteDialog={deleteDialog} />
    </Fragment>
  );

  function DeleteDialog({ deleteDialog }) {
    return (
      <MUIDialog open={deleteDialog.state} onClose={handleClose}>
        <DialogContent>
          <DialogContentText>
            You have selected the option to delete! Please confirm before going
            further.
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ padding: "0px 24px 16px" }}>
          <Reject
            onClick={() => {
              handleDelete(deleteDialog.event, deleteDialog.target);
              handleClose();
            }}
            variant="contained"
            color="primary"
          >
            Delete
          </Reject>
        </DialogActions>
      </MUIDialog>
    );
  }

  function handleFileChange({ target }, name) {
    let folderPath = "company_document/" + new Date().getTime() + "_";
    const file = get(target, "files[0]", "");
    let fileName = file?.name?.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, "");
    const uploadBucket = {
      name: "adn-media",
      region: "ap-south-1",
      identityPoolID: "ap-south-1:e58786e7-9711-4dea-a2e2-7d9c10e38333",
    };

    uploadToS3({
      bucket: uploadBucket,
      filePath: folderPath + fileName,
      file,
    }).then((response) => {
      if (response.status) {
        formikProps.setFieldValue(
          [name],
          "https://" +
            uploadBucket.name +
            ".s3.ap-south-1.amazonaws.com/" +
            folderPath +
            fileName
        );
      }
    });
  }
}
